import {useRouter as useRouterTanStack} from '@tanstack/react-router'

export {Outlet} from '@tanstack/react-router'

export * from './use-navigate'
export * from './use-search-params'
export * from './use-matches'
export * from './use-params'
export * from './use-loader-data'
export {useLocation} from './use-location'
export * from './use-navigation'
export * from './use-blocker'
export * from './use-blocker-legacy'
export * from './use-link-click-handler'
export * from './is-external-to-app'
export * from './link'

/**
 * Detect if an app is using TanStack Router.
 */
export function useIsTanStackRouter(): boolean {
  // useRouter returns a falsy value when not in a TanStack Router context
  const router = useRouterTanStack({warn: false})
  return !!router
}
